import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import getExpConfig from '../utils/getExpConfig';
import { API_UPLOAD_IMAGE, recordApiResponse } from '../utils/newRelic';

export const uploadImagestoS3 = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/uploadlogo`;
  const formData = new FormData();
  formData.append('file', params.file);
  formData.append('lineItemId', params.lineItemId);
  formData.append('uploadType', params.uploadType);
  formData.append('logoPosition', params.logoPosition);
  formData.append('ppeFileType', params.ppeFileType);

  const promise = axios.post(url, formData);
  return recordApiResponse(promise, API_UPLOAD_IMAGE, url, formData)
    .then((response) => toCamelCase(response))
    .catch((error) => error);
};
